var angular = require('angular');
var _module = require('../../module');
var config = require('config');
var _ = require('lodash');
var simpleCypher = require('../../../../libs/simple-cypher');

require('../../../services/verify-modal');
require('../../../services/login-or-register-modal');
require('../../../services/activity-feed');
require('../../../services/analytics');
require('../../third-party/angular-preload-image');

_module.requires.push('angular-preload-image');

_module.component('listItemCard', {
    controllerAs: 'lic',
    bindings: {
        data: '=listItemData',
        ui: '=uiFeedback',
        isMobile: '=isMobile',
        favoritedSearchFilterId: '<',
        currentView: '<',
        onClose: '&'
    },
    controller: [
        '$log',
        '$scope',
        '$state',
        '$window',
        '$user',
        'srUtils',
        '$verifyModal',
        '$loginOrRegisterModal',
        '$activityFeed',

        function listItemCardCtrl($log, $scope, $state, $window, $user, srUtils, $verifyModal, $loginOrRegisterModal, $activityFeed) {
            var _this = this;

            var favoriteListing = function () {
                var postBody = {
                    listing_id: _this.data.id,
                    listing_source: _this.data.listing_source,
                    listing: _this.data
                };

                if( _this.isSearchFilterResult ) {
                    postBody.searchFilterId = _this.usr.currentFilter.id;
                }else if(_this.favoritedSearchFilterId && _this.favoritedSearchFilterId.length > 0) {
                    postBody.searchFilterId = _this.favoritedSearchFilterId;
                }

                if(postBody){
                    $user.addFavorite(postBody)
                        .then(function (res) {
                            if(res && res.data) {
                                _this.isFavorite = true;
                                _this.favoriteId = res.data.id;
                                $log.debug('Added Favorite!', res);

                                $activityFeed.add({
                                    avatar: 'initials',
                                    type: 'lead',
                                    name: 'benoit_listing_favorited_by_user',
                                    userId: $user.affiliateId,
                                    meta: {
                                        benoitPartnerId: $user.affiliate.benoitPartnerId,
                                        benoitUserId: $user.id,
                                        name: $user.full_name,
                                        first_name: $user.first_name,
                                        last_name: $user.last_name,
                                        address: _this.data.address,
                                        listingId: simpleCypher.decode(_this.data.id).id,
                                        listing_source: _this.data.listing_source,
                                        filterId: $user.currentFilter ? $user.currentFilter.id : undefined
                                    }
                                });
                            }else {
                                $log.error('Couldnt set user\'s favorite');
                            }
                        })
                        .catch(function (err) {
                            $log.error('Error trying to favorite listing', err);
                        });
                }
            };

            var unfavoriteListing = function (id) {
                if(id){
                    $user.removeFavorite(id)
                        .then(function (res) {
                            _this.isFavorite = false;
                            _this.favoriteId = null;
                            $log.debug('Removed Favorite!', res);

                            $activityFeed.add({
                                avatar: 'initials',
                                type: 'lead',
                                name: 'benoit_listing_unfavorited_by_user',
                                userId: $user.affiliateId,
                                meta: {
                                    benoitPartnerId: $user.affiliate.benoitPartnerId,
                                    benoitUserId: $user.id,
                                    name: $user.full_name,
                                    first_name: $user.first_name,
                                    last_name: $user.last_name,
                                    address: _this.data.address,
                                    listingId: simpleCypher.decode(_this.data.id).id,
                                    listing_source: _this.data.listing_source,
                                    filterId: $user.currentFilter ? $user.currentFilter.id : undefined
                                }
                            });
                        })
                        .catch(function (err) {
                            $log.error('Error trying to favorite listing', err);
                        });
                }
            };

            var initFavoriteCheck = function () {
                _this.isFavorite = false;
                _this.favoriteId = null;

                if($user.favorites) {
                    _this.favorites = JSON.parse(JSON.stringify($user.favorites));

                    if( _this.favorites &&
                        angular.isArray(_this.favorites) &&
                        _this.favorites.length > 0) {

                        var query = {listing_id: _this.data.id};
                        if( _this.isSearchFilterResult ) {
                            query.searchFilterId = _this.usr.currentFilter.id;
                        }else if(_this.favoritedSearchFilterId && _this.favoritedSearchFilterId.length > 0) {
                            query.searchFilterId = _this.favoritedSearchFilterId;
                        }

                        var found = _.find(_this.favorites, query);

                        if(found) {
                            _this.isFavorite = true;
                            _this.favoriteId = found.id;
                        }
                    }
                }
            };

            var isSearchFilterResultCheck = function () {
                _this.isSearchFilterResult = !!(
                        _.has(_this, 'ui.resultSource') &&
                        _this.ui.resultSource === 'filter' &&
                        _.has(_this, 'usr.currentFilter.id')
                    );
            };

            var verifiedUserCheck = function () {
                if(_.has(_this, 'usr.account_type') &&
                    _this.usr.account_type &&
                    _this.usr.account_type.length > 0 ) {
                    switch(_this.usr.account_type.toLowerCase()) {
                        case 'verified':
                            return true;

                        case 'unverified':
                            $verifyModal();
                            return false;

                        case 'guest':
                        default:
                            $loginOrRegisterModal();
                            return false;
                    }
                }else{
                    $log.debug('No User or User Account Type found!');
                    $loginOrRegisterModal();
                    return false;
                }
            };

            var initNextOpenHouse = function () {
                _this.nextOpenHouse = _this.data.next_open_house || null;
                if(!_this.nextOpenHouse &&
                    _this.data &&
                    _this.data.open_houses) {
                    _this.nextOpenHouse = srUtils.getNextOpenHouse(_this.data);
                }
            };

            var init = function () {
                _this.usr = $user;
                initNextOpenHouse();
                isSearchFilterResultCheck();
            };

            init();


            /// PUBLIC API

            _this.toggleFavorite = function () {
                if(verifiedUserCheck()) {
                    if(String(_this.isFavorite) === 'true') {
                        unfavoriteListing(_this.favoriteId);
                    }else{
                        favoriteListing();
                    }
                }
            };

            _this.openDetailView = function (params) {
                srUtils.openDetailView(_this.data.detailViewParams);
            };

            _this.getCurrentFilterId = function () {
                return (!!_this.isSearchFilterResult)
                    ? _this.usr.currentFilter.id
                    :  (!!_this.favoritedSearchFilterId)
                        ? _this.favoritedSearchFilterId
                        : null;
            };


            /// WATCHERS

            $scope.$watch(function (scope) {
                return _this.usr.favorites;
            }, function (newVal, oldVal) {
                initFavoriteCheck();
            });

            if(_this.data) {
                $scope.$watch(function (scope) {
                    return _this.data.id;
                }, function (newVal, oldVal) {
                    if( newVal !== oldVal ) {
                        initNextOpenHouse();
                        if(String($user.loadingFavorites) === 'false') {
                            initFavoriteCheck();
                        }
                    }
                });
            }
        }
    ],
    template: require('./index.html')
});
